import { render, staticRenderFns } from "./CreateScreenSaver.vue?vue&type=template&id=5530a9e9&scoped=true&"
import script from "./CreateScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./CreateScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./CreateScreenSaver.vue?vue&type=style&index=0&id=5530a9e9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530a9e9",
  null
  
)

export default component.exports